module.exports = __webpack_public_path__ + "img/tag_backtotop.fb71b965.svg";